import {
  PUSH_SNACKBAR,
  ACKNOWLEDGE_SNACKBAR,
  REMOVE_SNACKBAR,
  SnackbarsReducerType
} from "store/actions/snackbars";

export enum ESnackType {
  ERROR = "error",
  SUCCESS = "success"
}

export interface ISnackbar {
  id: string;
  type: ESnackType;
  timestamp: number;
  message: string;
  isAcknowledged?: boolean;
}

export type SnackbarState = ISnackbar[];

export const initialState: SnackbarState = [];

export default (
  state = initialState,
  action: SnackbarsReducerType
): SnackbarState => {
  switch (action.type) {
    case PUSH_SNACKBAR:
      return [...state, action.snackbar];
    case ACKNOWLEDGE_SNACKBAR: {
      const newStateSnackbars = [...state];
      const index = newStateSnackbars.findIndex(
        snackbar => snackbar.id === action.snackbarId
      );
      newStateSnackbars[index] = {
        ...newStateSnackbars[index],
        isAcknowledged: true
      };
      return newStateSnackbars;
    }
    case REMOVE_SNACKBAR: {
      return [...state].filter(
        s => !s.isAcknowledged && s.id !== action.snackbarId
      );
    }
    default:
      return state;
  }
};
